import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/admin/examNotice'
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/auth/Login.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/admin',
    component: () => import('@/layout/AdminLayout.vue'),
    children: [
      { path: 'examNotice', name: '考试通知', component: () => import('@/views/admin/ExamNotice.vue') },
      { path: 'newsNotice', name: '新闻发布', component: () => import('@/views/admin/NewsNotice.vue') },
      { path: 'course', name: '课程管理', component: () => import('@/views/admin/Course.vue') },
      { path: 'question', name: 'AP真题', component: () => import('@/views/admin/Question.vue') },
      { path: 'profile', name: '个人中心', component: () => import('@/views/admin/AdminProfile.vue') },
      { path: 'examNotice/create', name: '新建考试通知', component: () => import('@/views/admin/ExamNoticeEdit.vue') },
      { path: 'examNotice/edit/:id', name: '编辑考试通知', component: () => import('@/views/admin/ExamNoticeEdit.vue') },
      { path: 'examNotice/view/:id', name: '考试通知详情', component: () => import('@/views/admin/ExamNoticeView.vue') },
      { path: 'newsNotice/create', name: '发布新闻', component: () => import('@/views/admin/NewsNoticeEdit.vue') },
      { path: 'newsNotice/edit/:id', name: '编辑新闻', component: () => import('@/views/admin/NewsNoticeEdit.vue') },
      { path: 'newsNotice/view/:id', name: '新闻详情', component: () => import('@/views/admin/NewsNoticeView.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = store.state.token
  if (!to.meta.noAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    const role = store.state.role
    if (role === 0) {
      next('/admin/examNotice')
    } else {
      next('/')
    }
  } else if (to.path.startsWith('/admin') && store.state.role !== 0) {
    next('/')
  } else {
    next()
  }
})

export default router
